import React from "react"
export default function Checkbox(props) {
    return <input type="checkbox" checked={props.value} {...props} />
}



// WEBPACK FOOTER //
// ./src/ui/legacy/Checkbox.js